import React, { useState, useRef } from "react";
import { Form, Select, DatePicker, Button } from "antd";
import { genderOptions, optionsFormStatus } from "constants/options";
import Filter from "assets/svgs/filter/Filter";
import { Offcanvas } from "react-bootstrap";

function LeadFilter({ query, setQuery, startDate, setStartDate,endDate, setEndDate}) {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    gender: null,
    formStatus: null,
  });

  const formRef = useRef(null);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFormChange = (changedValues, allValues) => {
    setFormData(allValues);
  };

  const handleFormSubmit = () => {
    const newQuery = {
      ...formData,
      startDate,
      endDate,
    };

    setQuery(newQuery);
  };

  const handleClear = () => {
    setFormData({
      startDate: null,
      endDate: null,
      gender: null,
      formStatus: null,
    });

    formRef.current.setFieldsValue({
      startDate: null,
      endDate: null,
      gender: null,
      formStatus: null,
    });
    setStartDate(null);
    setEndDate(null);

    setQuery(null);
  };

  return (
    <>
      <span variant="primary" className="cursor-pointer" onClick={handleShow}>
        <Filter />
      </span>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Case Filter</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form
            ref={formRef}
            initialValues={formData}
            onValuesChange={handleFormChange}
          >
            <Form.Item name="startDate">
              <DatePicker
                name="startDate" // Add this line
                dateFormat="yyyy-MM-dd"
                placeholderText="Start Date"
                isClearable
                maxDate={new Date()}
                className="form-control"
                onChange={(data)=>setStartDate(data)}
              />
            </Form.Item>
            <Form.Item name="endDate">
              <DatePicker
                name="endDate" // Add this line
                dateFormat="yyyy-MM-dd"
                placeholderText="End Date"
                isClearable
                maxDate={new Date()}
                className="form-control"
                onChange={(data)=>setEndDate(data)}
              />
            </Form.Item>
            <Form.Item name="gender">
              <Select
                allowClear
                style={{ width: "100%" }}
                dropdownStyle={{ minWidth: "6rem" }}
                options={genderOptions}
                placeholder="Gender"
                value={formData?.gender}
              />
            </Form.Item>
            <Form.Item name="formStatus">
              <Select
                style={{ width: "100%" }}
                allowClear
                dropdownStyle={{ minWidth: "6rem" }}
                options={optionsFormStatus}
                placeholder="Form Status"
              />
            </Form.Item>
            <div className="d-flex flex-row gap-2 w-100">
              <Form.Item className="w-50">
                <Button
                  className="bg-primary w-100 text-white text-center"
                  onClick={handleFormSubmit}
                >
                  Submit
                </Button>
              </Form.Item>
              <Form.Item className="w-50">
                <Button
                  className="bg-danger w-100 text-white text-center"
                  onClick={handleClear}
                >
                  clear
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default LeadFilter;
